export default __webpack_public_path__ + "static/media/international_boat_show.32fea3fd.webp";